<form
  [formGroup]="form"
  (ngSubmit)="submit()"
  data-hs-do-not-collect="true"
  class="tw-flex tw-flex-col tw-items-center tw-pt-6"
>
  <h1 class="tw-m-0 tw-text-center tw-font-rubik tw-text-xl tw-font-medium tw-leading-none tw-text-black">
    {{ 'auth_login.welcome' | translate }}
  </h1>

  <div class="tw-mt-[35px] tw-flex tw-w-full tw-max-w-[417px] tw-flex-col tw-gap-[25px]">
    <mh-core-lib-text-input
      [formGroup]="form"
      keyControl="email"
      type="email"
      [placeholder]="'auth_login.email_placeholder' | translate"
      [ariaLabel]="'auth_login.email_placeholder' | translate"
      autocomplete="username"
      className="mh-auth-input"
    >
    </mh-core-lib-text-input>

    @if (passwordRequired()) {
      <mh-core-lib-text-input
        [formGroup]="form"
        keyControl="password"
        [type]="showPassword() ? 'text' : 'password'"
        [hasIcon]="true"
        [iconClass]="(showPassword() ? 'fas fa-eye-slash' : 'fas fa-eye') + ' !tw-top-1/2 -tw-translate-y-1/2'"
        [iconAriaLabel]="'set_password.toggle_password_visibility' | translate"
        (clicked)="showPassword.set(!showPassword())"
        [placeholder]="'auth_login.password_placeholder' | translate"
        [ariaLabel]="'auth_login.password_placeholder' | translate"
        autocomplete="current-password"
        className="mh-auth-input"
      >
      </mh-core-lib-text-input>
    }
  </div>

  @if (errorKey()) {
    <p class="tw-mb-0 tw-mt-[14px] tw-w-full tw-max-w-[417px] tw-text-center tw-font-rubik tw-text-sm tw-text-red-500">
      {{ errorKey() | translate: errorParams() }}
    </p>
  }

  <div class="tw-mt-[29px]">
    <mh-core-lib-button
      [isPrimary]="true"
      [isDisabled]="!canSubmit()"
      [isDownloading]="loading()"
      [text]="'auth_login.submit' | translate"
      customClass="!tw-w-auto !tw-min-w-[110px] tw-whitespace-nowrap"
      loaderClass="tw-mx-auto"
      textClass="tw-font-rubik"
    ></mh-core-lib-button>
  </div>

  <a
    class="tw-mt-[26px] tw-font-rubik tw-text-sm tw-text-main-text tw-underline"
    routerLink="/recordar-contrasena"
    [class.tw-pointer-events-none]="loading()"
    [class.tw-opacity-50]="loading()"
    [attr.tabindex]="loading() ? -1 : null"
  >
    {{ 'auth_login.recover_password' | translate }}
  </a>

  @if (passwordRequired()) {
    <button
      type="button"
      class="tw-mt-[14px] tw-border-0 tw-bg-transparent tw-p-0 tw-font-rubik tw-text-sm tw-text-main-text tw-underline disabled:tw-cursor-not-allowed disabled:tw-text-disabled-font"
      [disabled]="loading()"
      (click)="back()"
    >
      <i class="far fa-arrow-left tw-mr-1"></i>{{ 'auth_login.back' | translate }}
    </button>
  }
</form>
